import { NgModule } from '@angular/core'
import { DataChartBoxComponent } from '@components/data-chart-box/data-chart-box.component'

@NgModule({
  imports: [],
  exports: [DataChartBoxComponent],
  declarations: [DataChartBoxComponent],
})
export class DataChartBoxModule {}
